export const vendorAddNote = {
    HEADER_TEXT: "Add Note",
    SUB_HEADER_TEXT:
      "Please enter your note below. Once saved, this will appear within the Claim Audit. This note will not be visible to the Trade Buyer.",
  }; 